module.exports = __webpack_public_path__ + "mp.svg?fec806e5ccb0f18ffcadac9464333cf1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mp.svg
// module id = 1507
// module chunks = 0